// extracted by mini-css-extract-plugin
export default {"title":"index_title_paEZA","titleList":"index_titleList_fZ5S3"};